import {combineReducers} from "redux";
import { call, put, select, takeLatest, delay } from 'redux-saga/effects';
import {reportsAPI} from "../../../api/reports";
import { createActions } from "../../factory/actionFactory";
import {START} from "../../../constants/action-postfix";
import { loaderReducer } from "./loader/loaderReducer";
import { formReducer } from "./form/formReducer";
import { dataReducer } from "./data/dataReducer";
import { reportParamsReducer } from "./reportParams/reportParamsReducer";
import { getEventsFormattedData, getFormParams } from "../../../utils/summGraduatesReports";



export const SUMM_GRADUATES_ORIENTATION_REQUEST = "SUMM_GRADUATES_ORIENTATION_REQUEST";
export const SET_FORM_DATA = "SET_SUMM_GRADUATES_ORIENTATION_FORM_DATA";
export const SET_REPORT_PARAMS = "SET_SUMM_GRADUATES_ORIENTATION_YEAR";

export const summGraduatesOrientationReducer = combineReducers({
    form: formReducer,
    data: dataReducer,
    loader: loaderReducer,
    report_params: reportParamsReducer
});

//actions
export const actions = createActions('report', SUMM_GRADUATES_ORIENTATION_REQUEST);
export const setFormData = payload => ({ type: SET_FORM_DATA, payload});
export const setReportParams = payload => ({ type: SET_REPORT_PARAMS, payload});

// SAGAS
export function* summGraduatesOrientationWatcher() {
    yield takeLatest(`${SUMM_GRADUATES_ORIENTATION_REQUEST}${START}`, summGraduatesOrientationWorker)
}

function* summGraduatesOrientationWorker () {
    try {
        const auth = yield select(state => state.auth.data)
        const form = yield select(state => state.reports.summGraduatesOrientation.form)
        const payload = getFormParams(form)
        const params = {...auth, ...payload}
        const response = yield call(reportsAPI.summGraduatesOrientation, params);
        const data = getEventsFormattedData(response.data.Answer.Data)
        yield put(actions.reportRequestSuccess(data));
        yield put(setReportParams(form))
    } catch(error) {
        yield put(actions.reportRequestError(error));
    }
}